export const generateFullTag = (
  tags: string[],
  blogUrl?: string,
  categoryName?: string
): [] | { name: string; url: string }[] => {
  if (!tags || !tags.length) {
    return []
  }

  const generateTagUrl = (blogUrl?: string, categoryName?: string, tag?: string) =>
    blogUrl && categoryName && tag
      ? `${blogUrl}?category=${encodeURIComponent(categoryName)}&tag=${encodeURIComponent(tag)}`
      : '#'

  return tags.map(tag => {
    return {
      name: tag,
      url: generateTagUrl(blogUrl, categoryName, tag),
    }
  })
}
